import { logError } from "../../../shared/logging";
import biClient from "../../api/biApi";
import { createTypedAsyncThunk } from "../utils/createTypedAsyncThunk.ts";
import { createClientSettingsAction } from "../utils/storeUtils.ts";

const defaultRejectedValue = "Failed to load client settings";

export const loadClientSettings = createTypedAsyncThunk(
  "clientSettings/loadClientSettings",
  async (_, { dispatch }) => {
    try {
      const response = await biClient.getClientSettings();
      if (response.success && response.data) {
        dispatch(createClientSettingsAction("setSettings", response.data));
        return response.data;
      }
      throw new Error(defaultRejectedValue);
    } catch (error) {
      logError(error, "loadClientSettings");
      throw new Error(defaultRejectedValue);
    }
  }
);
